import React, { useEffect, useState } from "react";
import LayoutDetails from "../../styles/components/LayoutDetails";

import AirplaneTicketIcon from "@mui/icons-material/AirplaneTicket";
import BackpackIcon from "@mui/icons-material/Backpack";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MenuIcon from "@mui/icons-material/Menu";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import {
  Box,
  Divider,
  Drawer,
  Grid2,
  Link,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Typography,
} from "@mui/material";
import logo from "../../assets/bellatchau.png";
interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props) => {
  const [drawner, setDrawner] = useState(false);
  const currentYear = new Date().getFullYear();
  return (
    <LayoutDetails>
      <header id="header">
        <div className="content-header">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="Logo" />
            </a>
          </div>

          <nav>
            <a href="/">Home</a>
            <a href="/viagens">Viagens</a>
            <a href="/sonhos-realizados">Sonhos realizados</a>
            <a href="/contato">Contato</a>
          </nav>
        </div>

        <div className="content-mobile">
          <MenuIcon fontSize="large" onClick={() => setDrawner(true)} />
          <Typography variant="h5">Bellatchau</Typography>
          <Drawer open={drawner} onClose={() => setDrawner(false)}>
            <Box
              sx={{ width: 250 }}
              role="presentation"
              onClick={() => setDrawner(false)}
            >
              <div
                className="logo-mobile"
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <Link href="/">
                  <img src={logo} alt="Logo" style={{ height: "70px" }} />
                </Link>
              </div>
              <Divider />
              <List sx={{ mt: 2 }}>
                <ListItem key="home" disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <Link underline="hover" href="/" sx={{ color: "black" }}>
                      Home
                    </Link>
                  </ListItemButton>
                </ListItem>
                <ListItem key="viagens" disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <AirplaneTicketIcon />
                    </ListItemIcon>
                    <Link
                      underline="hover"
                      href="/viagens"
                      sx={{ color: "black" }}
                    >
                      Viagens
                    </Link>
                  </ListItemButton>
                </ListItem>
                <ListItem key="viagens" disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <BackpackIcon />
                    </ListItemIcon>
                    <Link
                      underline="hover"
                      href="/sonhos-realizados"
                      sx={{ color: "black" }}
                    >
                      Sonhos realizados
                    </Link>
                  </ListItemButton>
                </ListItem>
                <ListItem key="contact" disablePadding>
                  <ListItemButton>
                    <ListItemIcon>
                      <EmailIcon />
                    </ListItemIcon>
                    <Link
                      underline="hover"
                      href="/contato"
                      sx={{ color: "black" }}
                    >
                      Contato
                    </Link>
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </div>
      </header>
      <div className="children">{children}</div>
      <div className="footer-top">
        <div className="content-footer-top">
          <Grid2 container justifyContent="space-between" rowGap={4}>
            <Grid2
              sx={{ color: "#fff" }}
              size={{ xs: 12, md: 3 }}
              flexDirection="column"
              gap={2}
              display="flex"
            >
              <Typography variant="h5" className="logo-footer">
                BELLATCHAU
              </Typography>
              <Typography variant="subtitle1">
                Descubra o mundo com estilo!
              </Typography>
            </Grid2>
            <Grid2
              size={{ xs: 12, md: 3 }}
              flexDirection="column"
              gap={2}
              display="flex"
            >
              <Typography variant="h6" color="#fff" fontWeight={600}>
                CONTATO
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    color: "#fff",
                    alignItems: "start",
                  }}
                >
                  <LocationOnIcon fontSize="small" />
                  <Typography variant="subtitle2">
                    Rua uruguai, número 612, Toledo Paraná
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    color: "#fff",

                    alignItems: "start",
                  }}
                >
                  <LocalPhoneIcon fontSize="small" />
                  <Typography variant="subtitle2">(45) 9 9849-4362</Typography>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    color: "#fff",

                    alignItems: "start",
                  }}
                >
                  <EmailIcon fontSize="small" />
                  <Typography variant="subtitle2">
                    atendimento@bellatchauviagens.com.br
                  </Typography>
                </Box>
              </Box>
            </Grid2>
            <Grid2
              size={{ xs: 12, md: 3 }}
              display="flex"
              flexDirection="column"
              gap={2}
              sx={{ color: "#fff" }}
            >
              <Typography variant="h6" color="#fff" fontWeight={600}>
                SOCIAL MEDIAS
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  color: "#fff",
                }}
              >
                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="https://www.instagram.com/bellatchauviagens?igsh=czU0cTZ4aTV4Nnp0"
                  target="_blank"
                  rel="noreferrer"
                >
                  <InstagramIcon
                    sx={{
                      cursor: "pointer",
                    }}
                  />
                </a>

                <a
                  style={{ textDecoration: "none", color: "#fff" }}
                  href="https://api.whatsapp.com/send/?phone=45998494362"
                  target="_blank"
                  rel="noreferrer"
                >
                  <WhatsAppIcon
                    sx={{
                      cursor: "pointer",
                    }}
                  />
                </a>
              </Box>
            </Grid2>
          </Grid2>
        </div>
      </div>
      <footer>
        <div className="content">
          <p>©BellaTchau {currentYear}, Todos Direitos Reservados.</p>
          <p>
            Desenvolvido por <a href="https://nirayuki.netlify.app">Nirayuki</a>
          </p>
        </div>
      </footer>
    </LayoutDetails>
  );
};

export default Layout;
